module.exports = __webpack_public_path__ + "img/feed-play.9d51047e.jpg";